import { ref, onUnmounted } from 'vue'

export type PanelSize = 'compact' | 'standard' | 'full'

const panelSize = ref<PanelSize>('full')

function classify(width: number): PanelSize {
  if (width < 500) return 'compact'
  if (width <= 900) return 'standard'
  return 'full'
}

/**
 * Attach a ResizeObserver to the given element and update
 * `data-panel-size` on `<html>` whenever the container width changes.
 * Call from App.vue's onMounted with a template ref to .app-container.
 */
export function usePanelSize(el: HTMLElement) {
  const update = () => {
    const size = classify(el.clientWidth)
    panelSize.value = size
    document.documentElement.setAttribute('data-panel-size', size)
  }

  const observer = new ResizeObserver(() => update())
  observer.observe(el)
  update()

  onUnmounted(() => observer.disconnect())

  return { panelSize }
}
